import React from 'react';
import { ButtonBase, styled } from '@mui/material';

// Tab del rail de auth (Ingresar / Crear cuenta). El indicador deslizante vive en
// AuthCard; aquí solo el estado del texto/ícono y el feedback táctil.
const StyledAuthRailTab = styled(({ active, ...otherProps }) => <ButtonBase {...otherProps} />)(
  ({ active, theme }) => ({
    alignItems: 'center',
    borderRadius: '13px',
    color: active ? theme.palette.text.primary : theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'inherit',
    fontSize: '0.8rem',
    fontWeight: active ? 800 : 600,
    gap: theme.spacing(0.5),
    justifyContent: 'center',
    minHeight: 48,
    padding: theme.spacing(1, 1.5),
    transition: 'color 200ms cubic-bezier(0.32, 0.72, 0, 1), transform 200ms cubic-bezier(0.32, 0.72, 0, 1)',
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.surface.overlay
    },
    '&:active': {
      transform: 'scale(0.98)'
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.gold.main}`,
      outlineOffset: 2
    }
  })
);

export default StyledAuthRailTab;
